// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/common/material-components/buttons/new-button.component.scss
// module id = 467
// module chunks = 6